export default __webpack_public_path__ + "static/media/live-updates.d791f7cb.gif";